export const prefetchedFolderIds = {};
